import React, { useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'

const CouponList = () => {
  const dispatch = useDispatch()

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Product',
      route: null
    },
    {
      label: 'Coupon',
      route: null
    },
  ]

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  return (
    <AuthLayout>
      <div>Coupon List</div>
    </AuthLayout>
  )
}

export default CouponList